<div class="input-group">
  <input type="text" class="form-control"  (keyup.enter)="search()" [(ngModel)]="searchText" i18n-placeholder="@@seach-article" placeholder="Article" aria-label="Article" aria-describedby="basic-addon2">
  <div class="input-group-append">
    <button class="btn main-bg-color text-white" (click)="search()" type="submit"><i class="fa fa-search"></i></button>    
  </div>  
</div>

